import styled from 'styled-components'
import { getDashColor } from '../../../styles'
import {
  PRIMARY_BLUE_02,
  GRAY_SCALE_09,
  GRAY_SCALE_05,
  GRAY_SCALE_04,
  PRIMARY_RED_10,
  SECONDARY_BLUE_10,
  SECONDARY_GREEN_10,
  SECONDARY_YELLOW_10,
  SECONDARY_ORANGE_10,
  WHITE,
} from 'bd-web-components/src/utils/dash-colors'
import CalendarDashboard from '../../../components/Calendar'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1325px;
  margin: 0 auto;
  margin-bottom: 162px;
  padding: 0px 64px;
  @media (max-width: 768px) {
    padding: 0px 24px;
  }
`

export const ContainerBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  max-width: 100%;
  padding: 32px;
  margin-top: 42px;
  background-color: ${getDashColor('GRAY_SCALE_10', 'LILAC_DARK')};
  border-radius: 8px;
  border: 1px solid ${GRAY_SCALE_09};
  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const ContentBox = styled.div`
  width: 50%;
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const FormDivider = styled.div`
  background-color: ${getDashColor('GRAY_SCALE_08', 'BEIGE')};
  width: 100%;
  height: 2px;
  margin-top: 29px;
  @media (max-width: 768px) {
    margin-top: 29px;
  }
`

export const PageSubtitle = styled.p`
  color: ${getDashColor('GRAY_SCALE_05', 'GRAY_DARK')};
  opacity: 0.6;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  @media (max-width: 768px) {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`

export const PageTitle = styled.h4`
  color: ${getDashColor('PRIMARY_BLUE_02', 'GRAY_DARK')};
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 35.2px; /* 110% */
  margin-bottom: 19px;
  @media (max-width: 768px) {
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 110% */
    margin-bottom: 13px;
  }
`

export const TextHeaderBox = styled.div`
  width: 70%;
  &:only-child {
    width: 100%;
  }
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const ButtonHeaderBox = styled.div`
  width: 30%;
  display: flex;
  justify-content: flex-end;
  @media (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    justify-content: flex-start;
    margin-top: 25px;
  }
`

export const PageHeaderBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    max-width: 100%;
  }
`

export const PageOptions = styled.h5`
  color: ${PRIMARY_BLUE_02};
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
  margin-top: 32px;
  margin-bottom: 24px;
  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 13px;
  }
`

export const ContainerButtons = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
`

export const StatsGroup = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 8px;
`

export const StatsGroupTitle = styled.h6`
  color: ${getDashColor('PRIMARY_BLUE_02', 'GRAY_DARK')};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  margin: 16px 0 4px;
`

export const ContainerCard = styled.div`
  min-width: 0;
  width: 100%;
  height: 100%;
`

export const DetailCard = styled.div`
  display: flex;
  align-items: flex-start;
  min-height: 118px;
  height: 100%;
  border: 1px solid ${getDashColor('GRAY_SCALE_09', 'BEIGE')};
  border-radius: 5px;
  padding: 16px 24px;
  margin-top: 8px;
  box-sizing: border-box;

  @media (max-width: 1152px) {
    width: 100%;
  }
`

export const LabelCard = styled.div`
  color: ${GRAY_SCALE_04};
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding: 0 20px;
  align-content: center;
  flex: 1;
  min-width: 0;
`

export const CardTitle = styled.div`
  color: ${PRIMARY_BLUE_02};
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 19.6px;
  margin-top: 6px;
`

export const CardDescription = styled.p`
  color: ${GRAY_SCALE_05};
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.35;
  margin: 6px 0 0;
`

export const CardAction = styled.div`
  margin-top: 12px;
`

export const BoxTitle = styled.div`
  color: ${getDashColor('PRIMARY_BLUE_01', 'WHITE')};
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
`

export const BoxSubtitle = styled.div`
  color: ${getDashColor('PRIMARY_BLUE_01', 'WHITE')};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22.4px;
  margin-bottom: 26px;
`

export const ContractServiceButton = styled.button`
  color: ${WHITE};
  background: ${getDashColor('SECONDARY_BLUE_01', 'LILAC_LIGHT')};
  height: 48px;
  maxwidth: 100%;
  variant: contained;
  width: 252px;
  border-radius: 100px;
  border-color: transparent;
`

export const IconDetailContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-shrink: 0;
  width: 42px;
  height: 42px;
  &:before {
    content: '';
    width: 42px;
    height: 42px;
    background-color: ${PRIMARY_RED_10};
    border-radius: 100px;
    position: absolute;
    z-index: 0;
  }
  & div {
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &.graph {
    &:before {
      background-color: ${SECONDARY_BLUE_10};
    }
  }
  &.success {
    &:before {
      background-color: ${SECONDARY_GREEN_10};
    }
  }
  &.avg {
    &:before {
      background-color: ${SECONDARY_YELLOW_10};
    }
  }
  &.warning {
    &:before {
      background-color: ${SECONDARY_ORANGE_10};
    }
  }
`

export const ImgBdCrmBonus = styled.img`
  width: 50%;
  height: content-fit;
  padding-left: 32px;
  align-self: center;
  @media (max-width: 768px) {
    width: 100%;
    padding: 15px 0;
  }
`;

export const CalendarDashboardStyled = styled(CalendarDashboard)`
  background: ${WHITE};
  border-color: ${getDashColor('GRAY_SCALE_09', 'BEIGE')};
  max-width: 80px;
  .CalendarIcon {
    background-color: black;
    filter: invert(1);
  }
  &.hidden {
    display: none;
  }
`
